$(document).ready(function() {

  let is_menu = false
  $(".idd-menu-project").click((event) => {
    event.stopPropagation()
    if (is_menu) {
      $(".idd-menu-layout").addClass("hidden");
      is_menu = false
    } else {
      $(".idd-menu-layout").removeClass("hidden");
      is_menu = true
    }
  })

  let is_m_menu = false
  $(".idd-m-menu-all").click((event) => {
    event.stopPropagation()
    if (is_m_menu) {
      $(".idd-m-menu-layout").addClass("hidden");
      is_m_menu = false
    } else {
      $(".idd-m-menu-layout").removeClass("hidden");
      is_m_menu = true
    }
  })

  $(".idd-m-menu-close").click(()=>{
    $(".idd-m-menu-layout").addClass("hidden");
    is_m_menu = false
  })

  $(document).on('click',function(event){
    let menu_layout = $(".idd-menu-project,.idd-menu-layout")
    if(!menu_layout.is(event.target)&&menu_layout.has(event.target).length === 0){
      $(".idd-menu-layout").addClass("hidden");
      is_menu = false
    }
  })

  let scroll_top = $(document).scrollTop()
  if (scroll_top > 0) {
    $(".idd-nav-bg").css("opacity", 100)
  }

  $(window).scroll(function() {
    if ($(document).scrollTop()<=0){
      $(".idd-nav-bg").css("opacity", 0)
    } else {
      $(".idd-nav-bg").css("opacity", 100)
    }
  })
  
})